import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

/**
 * Opts a dialog into the v2 design layer.
 *
 * NgbModal renders into a container at the end of <body>, so a dialog is never
 * inside the opening page's `.evo-v2` wrapper and cannot inherit the layer the
 * way the rest of the page does. `windowClass` puts the hook on ng-bootstrap's
 * own window element instead, where the `.evo-modal` half of every selector in
 * styles/evo-v2/_components.scss can reach it.
 *
 * Spread it into the options of every dialog opened from a v2 page:
 *
 *   modal.open(SuggestDataComponent, { ...EVO_MODAL });
 *
 * Pages that have not migrated simply do not pass it and keep the Bootstrap
 * dialog they have today.
 */
export const EVO_MODAL: NgbModalOptions = {
  windowClass: 'evo-modal',
  centered: true,
};
